module.exports = new __parcel__URL__("resources_tab_inactive.c4e23dad.png").toString();